import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

import type { ExtendedOptions } from '@/components/Chart/types/highcharts';
import { Z_INDEX } from '@/constants/z-index';

import LegendItem from './LegendItem';

import type { TableCellProps } from '@mui/material';

const getTableCells = (
  isFullTitle: boolean
): ({ name: string } & Pick<TableCellProps, 'align'>)[] => [
  {
    name: 'Code'
  },
  {
    name: 'Time Ref',
    align: 'right'
  },
  {
    name: 'Period Type',
    align: 'right'
  },
  {
    name: 'Period',
    align: 'right'
  },
  {
    name: 'Alias'
  },
  {
    name: isFullTitle ? 'Full Title' : 'Title'
  },

  {
    name: 'Currency',
    align: 'right'
  },
  {
    name: 'Units',
    align: 'right'
  },
  {
    name: 'Info',
    align: 'right'
  }
];
const FullScreenLegend = ({
  options,
  isFullTitle = false
}: {
  options: ExtendedOptions;
  isFullTitle?: boolean;
}) => {
  const tableCells = getTableCells(isFullTitle);

  return (
    <Box sx={{ pt: 1, pr: 3 }}>
      <TableContainer
        component={Paper}
        sx={{ width: '100%', pl: '78px', maxHeight: 155, pr: 1 }}
      >
        <Table
          aria-label='api keys table'
          size='small'
          sx={{
            minWidth: 600,
            minHeight: options.series ? options.series.length * 25 + 50 : 0,
            thead: {
              top: 0,
              zIndex: Z_INDEX.chartOverlay
            }
          }}
        >
          <TableHead>
            <TableRow sx={{ '.MuiTableCell-head': { backgroundColor: 'background.paper' } }}>
              <TableCell />
              {tableCells.map((cell, index) => (
                <TableCell
                  key={cell.name}
                  align={cell.align}
                  sx={{ pr: tableCells.length - 1 === index ? 0 : 5, whiteSpace: 'nowrap' }}
                >
                  <Typography
                    sx={theme => ({ color: theme.palette.info.dark })}
                    variant='body2'
                  >
                    {cell.name}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody sx={{ maxHeight: 150 }}>
            {options.series?.map(series => (
              <LegendItem
                key={series.id}
                series={series}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default FullScreenLegend;
